import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthService } from './shared/service/auth.service';
@Component({
    selector: 'app-root',
    imports: [RouterModule, NgxSpinnerModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'nox-frontend';

  constructor(private readonly authService: AuthService) {}
}
